export default __webpack_public_path__ + "static/media/a011-example6.9df44e85.jpg";